<template>
  <div class="payment">
    <div v-show="!failedPayment">
      <!-- Card Holder Name -->
      <div class="wwf-field">
        <input
          id="card-holder-name"
          name="card-holder-name"
          aria-label="Card holder name"
          v-model="cardHolderName"
          type="text"
          autocomplete="cc-name"
          ref="cardHolderName"
          v-validate="'required'"
          :class="{
            error: errors.has('cardHolderName'),
            empty: !cardHolderName,
          }"
        />
        <label for="title">Card holder name</label>
      </div>

      <!-- Card Number -->
      <div class="wwf-field">
        <div
          id="card-number"
          class="input"
          :class="{
            error: cardNumberError,
            empty: isCardNumberEmpty,
            focus: isCardNumberFocused,
          }"
        ></div>
        <label for="title">Card Number</label>
      </div>

      <div class="row">
        <!-- Card Expiry -->
        <div class="wwf-field">
          <div
            id="card-expiry"
            class="input"
            :class="{
              error: cardExpiryError,
              empty: isExpiryEmpty,
              focus: isExpiryFocused,
            }"
          ></div>
          <label for="title">MM / YY</label>
        </div>

        <!-- Card CVV -->
        <div class="wwf-field">
          <div
            id="card-cvv"
            class="input"
            :class="{
              error: cardCVVError,
              empty: isCVVEmpty,
              focus: isCVVFocused,
            }"
          ></div>
          <label for="title">CVV / CVC</label>
        </div>
      </div>
    </div>

    <!-- ERROR -->
    <div class="errors" v-if="hasErrors">
      <label for="card-number" id="card-number-error">
        {{ cardNumberError }}
      </label>
      <label for="card-cvv" id="card-cvv-error">
        {{ cardCVVError }}
      </label>
      <label for="card-expiry" id="card-expiry-error">
        {{ cardExpiryError }}
      </label>
      <label
        v-if="errors.has('cardHolderName')"
        for="card-holder-name"
        id="card-holder-name-error"
      >
        Card holder name incorrect
      </label>
      <label>{{ serverError }}</label>
    </div>

    <div class="form-buttons" v-if="!failedPayment">
      <button
        type="button"
        class="pay-now"
        :class="{ disabled: !activatePayButton() }"
        :disabled="!activatePayButton()"
        href="#form-top"
        id="pay-button"
        @click="pay"
      >
        <span v-if="!isLoading">{{ submitButtonMessage }}</span>
        <span v-if="isLoading">
          <i class="far fa-spinner-third fa-spin"></i>
        </span>
      </button>
    </div>

    <div class="form-buttons" v-if="failedPayment">
      <button
        type="button"
        class="pay-now"
        href="#form-top"
        id="retry-button"
        @click="retry"
        :class="{ disabled: isLoading }"
        :disabled="isLoading"
      >
        <span v-if="!isLoading">Retry</span>
        <span v-if="isLoading">
          <i class="far fa-spinner-third fa-spin"></i>
        </span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "CreditCard",
  data() {
    return {
      customCheckout: customcheckout(),
      isCardNumberComplete: false,
      isCVVComplete: false,
      isExpiryComplete: false,
      isCardNumberEmpty: true,
      isCVVEmpty: true,
      isExpiryEmpty: true,
      isCardNumberFocused: false,
      isCVVFocused: false,
      isExpiryFocused: false,
      cardHolderName: "",
      cardHolderNameError: undefined,
      cardNumberError: undefined,
      cardCVVError: undefined,
      cardExpiryError: undefined,
      isLoading: false,
      isPayButtonDisabled: false,
      serverError: undefined,
      failedPayment: false,
      bamboraInputs: {
        cardNumber: undefined,
        expiryTime: undefined,
        cvvNumber: undefined,
      },
    };
  },
  props: {
    submitButtonMessage: {
      type: String,
      default: "pay Now",
    },
  },
  mounted() {
    this.initForm();
    this.initCustomCheckoutEvents();
  },
  computed: {
    hasErrors() {
      return (
        this.cardNumberError ||
        this.cardCVVError ||
        this.cardExpiryError ||
        this.serverError
      );
    },
    ...mapState({
      donation: (state) => state.donation.donation,
    }),
  },
  methods: {
    initForm() {
      // Set the font size for the inputs inside the injected iframes
      let style = {
        base: {
          fontSize: "15px",
        },
      };
      var options = {
        style,
      };

      this.cardHolderName = "";

      // Create and mount the inputs
      this.bamboraInputs.cardNumber = this.customCheckout.create(
        "card-number",
        options
      );
      this.bamboraInputs.cardNumber.mount("#card-number");
      this.bamboraInputs.cvvNumber = this.customCheckout.create("cvv", options);
      this.bamboraInputs.cvvNumber.mount("#card-cvv");
      this.bamboraInputs.expiryTime = this.customCheckout.create(
        "expiry",
        options
      );
      this.bamboraInputs.expiryTime.mount("#card-expiry");
    },

    initCustomCheckoutEvents() {
      // Setup empty input state
      this.customCheckout.on("empty", (event) => {
        if (event.empty) {
          if (event.field === "card-number") {
            this.isCardNumberEmpty = true;
            this.toggleCardNumberComplete(false);
          } else if (event.field === "cvv") {
            this.isCVVEmpty = true;
            this.toggleCVVComplete(false);
          } else if (event.field === "expiry") {
            this.isExpiryEmpty = true;
            this.toggleExpiryComplete(false);
          }
        } else {
          if (event.field === "card-number") {
            this.isCardNumberEmpty = false;
          } else if (event.field === "cvv") {
            this.isCVVEmpty = false;
          } else if (event.field === "expiry") {
            this.isExpiryEmpty = false;
          }
        }
      });

      // Setup focus input state
      this.customCheckout.on("focus", (event) => {
        if (event.field === "card-number") {
          this.isCardNumberFocused = true;
        } else if (event.field === "cvv") {
          this.isCVVFocused = true;
        } else if (event.field === "expiry") {
          this.isExpiryFocused = true;
        }
      });

      // Setup blur input state
      this.customCheckout.on("blur", (event) => {
        if (event.field === "card-number") {
          this.isCardNumberFocused = false;
        } else if (event.field === "cvv") {
          this.isCVVFocused = false;
        } else if (event.field === "expiry") {
          this.isExpiryFocused = false;
        }
      });

      // Setup error input state
      this.customCheckout.on("error", (event) => {
        if (event.field === "card-number") {
          console.log("Card number has errors: ", event);
          this.cardNumberError = event.message;
        } else if (event.field === "cvv") {
          console.log("CVV has errors: ", event);
          this.cardCVVError = event.message;
        } else if (event.field === "expiry") {
          console.log("Expiry has errors: ", event);
          this.cardExpiryError = event.message;
        }
      });

      // Display card brand logo in the card number input
      this.customCheckout.on("brand", (event) => {
        let cardLogo = "none";
        if (event.brand && event.brand !== "unknown") {
          let filePath = `https://cdn.na.bambora.com/downloads/images/cards/${event.brand}.svg`;
          cardLogo = "url(" + filePath + ")";
        }
        document.getElementById("card-number").style.backgroundImage = cardLogo;
      });

      this.customCheckout.on("complete", (event) => {
        if (event.field === "card-number") {
          this.cardNumberError = undefined;
          this.serverError = "";
          this.toggleCardNumberComplete(true);
          console.log("Card number is complete: ", event);
        } else if (event.field === "cvv") {
          this.toggleCVVComplete(true);
          this.serverError = "";
          this.cardCVVError = undefined;
          console.log("CVV is complete: ", event);
        } else if (event.field === "expiry") {
          this.toggleExpiryComplete(true);
          this.cardExpiryError = undefined;
          this.serverError = "";
          console.log("Expiry is complete: ", event);
        }
      });
    },
    resetForm() {
      this.bamboraInputs.expiryTime.clear();
      this.bamboraInputs.cardNumber.clear();
      this.bamboraInputs.cvvNumber.clear();
      this.cardHolderName = "";

      // No need to reset the "complete" flags. In case of copy paste of a good card, the "complete" trigger won't fire.
      // If the user enter a wrong card number, the "error" trigger will fire anyway.
      // Trying to pay with empty field will just fail the payment.

      document.getElementById("card-number").style.backgroundImage = "";
    },
    resetFormErrors() {
      this.cardNumberError = undefined;
      this.cardCVVError = undefined;
      this.cardExpiryError = undefined;
      this.serverError = undefined;
      this.cardHolderName = "";
    },
    togglePayButtonDisabled(value) {
      //disable pay-button
      this.isPayButtonDisabled = value;
    },
    cardHolderNameIsValid() {
      return this.cardHolderName && this.cardHolderName.length > 3
        ? true
        : false;
    },
    activatePayButton() {
      // Activate pay Button only if all the field are complete and there is no errors
      return (
        this.isCardNumberComplete &&
        this.isExpiryComplete &&
        this.isCVVComplete &&
        !this.cardNumberError &&
        !this.cardCVVError &&
        !this.cardExpiryError &&
        !this.serverError &&
        this.cardHolderNameIsValid() &&
        !this.isPayButtonDisabled
      );
    },
    toggleCardNumberComplete(value) {
      this.isCardNumberComplete = value;
    },
    toggleCVVComplete(value) {
      this.isCVVComplete = value;
    },
    toggleExpiryComplete(value) {
      this.isExpiryComplete = value;
    },
    pay() {
      this.togglePayButtonDisabled(true);
      this.isLoading = true;
      console.log("Pay - Create one time token");
      this.customCheckout.createOneTimeToken(
        wwfconfigs.MERCHANTID,
        this.processToken
      );
    },
    processToken(result) {
      console.log("token result : ", result);
      this.isLoading = false;
      if (result.error) {
        this.processTokenError(result.error);
      } else {
        this.processTokenSuccess(result.token);
      }
    },
    processTokenError(error) {
      console.log("processTokenError: ", error);
      if (error.message) {
        this.serverError = error.message;
      } else {
        this.serverError =
          "Unable to process transaction. Please try again later.";
      }
      this.togglePayButtonDisabled(false);
      this.failedPayment = true;
    },
    processTokenSuccess(token) {
      console.log("processTokenSuccess: " + token);
      this.serverError = undefined;

      this.$emit("success", {
        token,
        cardHolderName: this.cardHolderName,
      });
    },
    retry() {
      this.isLoading = true;
      this.$emit("retry");
      this.resetForm();
      this.resetFormErrors();
      this.isLoading = false;
    },
    reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.resetFormErrors();
        this.failedPayment = false;
      }
      this.togglePayButtonDisabled(false);
    },
  },
};
</script>

<style scoped>
.input {
  background-image: none;
  background-origin: content-box;
  background-position: 100% center;
  background-repeat: no-repeat;
  background-size: 30px;
}

.row {
  display: flex;
  gap: 15px;
}

.errors {
  margin-bottom: 20px;
}

.errors label {
  font-size: 15px;
  color: var(--errorColor);
  display: block;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// CreditCard.vue?e0d0c2ca